<template>
  <div class="best-bet-container">
    <v-card flat class="modern-card">
      <v-row justify="center" class="pa-4" v-if="bestBet.doc">
        <v-col cols="12" class="text-center mb-6">
          <h2 class="section-title mb-4">{{ sport }} Best Bets</h2>
          <v-btn-toggle
              color="primary"
              v-model="toggle_exclusive"
              rounded
              mandatory
              class="expert-toggle"
          >
            <v-btn
              @change="handleClick('6107f818963dc87f216fa505')"
              class="expert-btn"
              elevation="2"
            >
              <v-icon left small>mdi-account-star</v-icon>
              Chazmule
            </v-btn>

            <v-btn
              @change="handleClick('60fedc56109bcffeb7010994')"
              class="expert-btn"
              elevation="2"
            >
              <v-icon left small>mdi-account-star</v-icon>
              doughboys123
            </v-btn>
          </v-btn-toggle>
        </v-col>

        <v-col cols="12">
          <v-col cols="12" md="10" lg="8" class="mx-auto mb-4">
            <v-card elevation="8" rounded="xl" class="tier-card gold-tier">
              <div class="tier-header gold-header">
                <v-icon left color="#ffd700" size="28">mdi-trophy</v-icon>
                <h3 class="tier-title">GOLD </h3>
                <v-chip small class="tier-badge" color="#ffd700" text-color="black">
                  Gold
                </v-chip>
              </div>
              <v-card-text class="tier-content">
                <span v-html="bestBet.doc.gold"></span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="10" lg="8" class="mx-auto mb-4">
            <v-card elevation="6" rounded="xl" class="tier-card silver-tier">
              <div class="tier-header silver-header">
                <v-icon left color="#c0c0c0" size="28">mdi-medal</v-icon>
                <h3 class="tier-title">SILVER </h3>
                <v-chip small class="tier-badge" color="#c0c0c0" text-color="black">
                  Silver
                </v-chip>
              </div>
              <v-card-text class="tier-content">
                <span v-html="bestBet.doc.silver"></span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="10" lg="8" class="mx-auto mb-4">
            <v-card elevation="4" rounded="xl" class="tier-card bronze-tier">
              <div class="tier-header bronze-header">
                <v-icon left color="#cd7f32" size="28">mdi-medal-outline</v-icon>
                <h3 class="tier-title">BRONZE </h3>
                <v-chip small class="tier-badge" color="#cd7f32" text-color="white">
                  Bronze
                </v-chip>
              </div>
              <v-card-text class="tier-content">
                <span v-html="bestBet.doc.bronze"></span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="10" lg="8" class="mx-auto">
            <v-card elevation="3" rounded="xl" class="remark-card">
              <v-card-text class="remark-content">
                <div class="remark-header">
                  <v-icon left color="#17408B">mdi-information-outline</v-icon>
                  <span class="remark-title">Important Notes</span>
                </div>
                <div class="remark-text">
                  <span v-html="bestBet.doc.remark"></span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "BestBet",
  props: {
    sport: {
      type: String,
      default: "NFL",
    },
    sportId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      toggle_exclusive: 0,
    };
  },
  mounted() {
   this.handleClick('6107f818963dc87f216fa505')
  },

  computed: mapState("userModule", ["bestBet"]),

  methods: {
    handleClick(id) {
      this.$store.dispatch("userModule/getBestBet", { sportId: this.sportId, id });
    },
  }
};
</script>

<style scoped>
.best-bet-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 16px 8px;
}

.modern-card {
  background: transparent !important;
  box-shadow: none !important;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  color: #17408B;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.expert-toggle {
  border-radius: 25px !important;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.expert-btn {
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.tier-card {
  margin-bottom: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: white;
  border: 1px solid rgba(0,0,0,0.05);
}

.tier-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0,0,0,0.15) !important;
}

.tier-header {
  padding: 20px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

.tier-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  flex-grow: 1;
  margin-left: 12px;
}

.tier-badge {
  font-weight: 600;
  font-size: 0.75rem;
}

.tier-content {
  padding: 24px !important;
  line-height: 1.7;
  font-size: 1rem;
}

.gold-tier {
  background: linear-gradient(135deg, #fff9e6 0%, #fff5cc 100%);
  border-left: 4px solid #ffd700;
}

.gold-header {
  background: linear-gradient(90deg, rgba(255,215,0,0.1) 0%, rgba(255,215,0,0.05) 100%);
}

.silver-tier {
  background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f4 100%);
  border-left: 4px solid #c0c0c0;
}

.silver-header {
  background: linear-gradient(90deg, rgba(192,192,192,0.1) 0%, rgba(192,192,192,0.05) 100%);
}

.bronze-tier {
  background: linear-gradient(135deg, #fdf6f0 0%, #f7e6d3 100%);
  border-left: 4px solid #cd7f32;
}

.bronze-header {
  background: linear-gradient(90deg, rgba(205,127,50,0.1) 0%, rgba(205,127,50,0.05) 100%);
}

.remark-card {
  background: linear-gradient(135deg, #e3f2fd 0%, #f0f8ff 100%);
  border-left: 4px solid #17408B;
}

.remark-content {
  padding: 24px !important;
}

.remark-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.remark-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #17408B;
  margin-left: 8px;
}

.remark-text {
  line-height: 1.7;
  font-size: 1rem;
  color: #333;
}

/* Mobile Optimizations */
@media (max-width: 768px) {
  .best-bet-container {
    padding: 8px 4px;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .expert-btn {
    padding: 10px 16px !important;
    font-size: 0.9rem !important;
  }

  .tier-header {
    padding: 16px 20px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .tier-title {
    font-size: 1.25rem;
    margin-left: 0;
  }

  .tier-content {
    padding: 16px !important;
    font-size: 0.95rem;
  }

  .remark-content {
    padding: 16px !important;
  }

  .remark-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .expert-toggle {
    width: 100%;
  }

  .expert-btn {
    flex: 1;
    padding: 12px 8px !important;
    font-size: 0.85rem !important;
  }

  .tier-header {
    padding: 12px 16px 8px;
  }

  .tier-content {
    padding: 12px !important;
  }
}
</style>
